export default __webpack_public_path__ + "static/media/ic_image_upload.d115467f.svg";